import { render } from "./InventoryDash.vue?vue&type=template&id=f496e9b6&scoped=true"
import script from "./InventoryDash.vue?vue&type=script&lang=js"
export * from "./InventoryDash.vue?vue&type=script&lang=js"

import "./InventoryDash.vue?vue&type=style&index=0&id=f496e9b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f496e9b6"]])

export default __exports__